"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalWidth = exports.modalHeight = exports.StyledModalContainer = exports.PositionerAbsolute = exports.FillScreen = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _layers = require("../../../constants/layers");
var _sharedVariables = require("../shared-variables");
var _modalTheme = require("./modalTheme");
const maxWidthDimensions = `calc(100% - ${_sharedVariables.gutter * 2}px)`;
const maxHeightDimensions = gutterHeight => {
  if (typeof gutterHeight === "string") {
    const percent = parseInt(gutterHeight);
    return `${100 - percent * 2}%`;
  }
  const gutterHeightPx = typeof gutterHeight === "number" ? gutterHeight : _sharedVariables.gutter;
  return `calc(100% - ${gutterHeightPx * 2}px)`;
};
const modalWidth = _ref => {
  let {
    widthName,
    widthValue
  } = _ref;
  if (typeof widthValue === "number") {
    return `${widthValue}px`;
  }
  return widthName ? `${_sharedVariables.WIDTH_ENUM.widths[widthName]}px` : widthValue || "auto";
};
exports.modalWidth = modalWidth;
const modalHeight = _ref2 => {
  let {
    heightValue
  } = _ref2;
  if (typeof heightValue === "number") {
    return `${heightValue}px`;
  }
  return heightValue || "auto";
};
exports.modalHeight = modalHeight;
const positionerAbsoluteTop = gutterHeight => {
  if (typeof gutterHeight === "string") {
    return gutterHeight;
  }
  const gutterHeightPx = typeof gutterHeight === "number" ? gutterHeight : _sharedVariables.gutter;
  return `${gutterHeightPx}px`;
};
const FillScreen = (0, _styled.default)("div")`
    height: 100vh;
    left: 0;
    overflow-y: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: ${_layers.layers.modal};
    -webkit-overflow-scrolling: touch;
`;
exports.FillScreen = FillScreen;
FillScreen.displayName = "StyledFillScreen";
const PositionerAbsolute = (0, _styled.default)("div")`
    position: absolute;
    top: ${_ref3 => {
  let {
    gutterHeight
  } = _ref3;
  return positionerAbsoluteTop(gutterHeight);
}};
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: ${_ref4 => {
  let {
    placement
  } = _ref4;
  return placement === "center" ? "center" : "flex-start";
}};
    height: ${_ref5 => {
  let {
    gutterHeight
  } = _ref5;
  return maxHeightDimensions(gutterHeight);
}};
    max-width: ${maxWidthDimensions};
    margin-left: auto;
    margin-right: auto;
    z-index: ${_layers.layers.modal};
    pointer-events: none;

    @media (min-width: 320px) and (max-width: 480px) {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        max-width: 100%;
    }
`;
exports.PositionerAbsolute = PositionerAbsolute;
PositionerAbsolute.displayName = "StyledPositionerAbsolute";
const StyledModalContainer = (0, _styled.default)("div")`
    ${props => {
  return {
    ...props.cssVariables
  };
}}

    background-color: ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return _modalTheme.modalTheme.backgroundColor(themeMode);
}};
    border-radius: ${_ref7 => {
  let {
    themeMode,
    heightValue
  } = _ref7;
  return heightValue === "100vh" ? "0px" : _modalTheme.modalTheme.borderRadius(themeMode);
}};
    box-shadow: ${_ref8 => {
  let {
    themeMode
  } = _ref8;
  return _modalTheme.modalTheme.boxShadow(themeMode);
}};
    color: ${_ref9 => {
  let {
    themeMode
  } = _ref9;
  return _modalTheme.modalTheme.color(themeMode);
}};
    display: flex;
    flex-direction: column;
    height: ${_ref10 => {
  let {
    heightValue
  } = _ref10;
  return modalHeight({
    heightValue
  });
}};
    max-height: 100%;
    min-height: 264px;

    /* the parent (PositionerAbsolute) turns off pointer events, so we need to turn it back on */
    pointer-events: auto;

    @media (min-width: 320px) and (max-width: 480px) {
        height: 100%;
        max-height: 100%;
        border-radius: 0;
    }
`;
exports.StyledModalContainer = StyledModalContainer;
StyledModalContainer.displayName = "StyledModalContainer";
//# sourceMappingURL=Modal.js.map